<template>
	<div class="container">
		<div class="tipWrap">
			<p class="tipTitle">温馨提示</p>
			<div class="result_success">
				<svg
					t="1624526713513"
					class="icon"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="2521"
					width="28"
					height="28"
				>
					<path
						d="M918.795922 356.854687c-21.798121-51.476314-52.909055-97.631021-92.514092-137.236058-39.605037-39.605037-85.862083-70.818309-137.236058-92.514092C635.727364 104.590046 579.236458 93.128123 520.903458 93.128123s-114.823906 11.461923-168.142315 33.976414c-51.476314 21.798121-97.631021 52.909055-137.236058 92.514092s-70.818309 85.862083-92.514092 137.236058C100.496502 410.173096 89.034579 466.664002 89.034579 524.997002s11.461923 114.823906 33.976414 168.142315c21.798121 51.476314 52.909055 97.631021 92.514092 137.236058 39.605037 39.605037 85.862083 70.818309 137.236058 92.514092 53.21607 22.514491 109.809314 33.976414 168.142315 33.976414s114.823906-11.461923 168.142315-33.976414c51.476314-21.798121 97.631021-52.909055 137.236058-92.514092 39.605037-39.605037 70.818309-85.862083 92.514092-137.236058 22.514491-53.21607 33.976414-109.809314 33.976414-168.142315S941.310414 410.173096 918.795922 356.854687zM520.903458 911.836898c-213.273636 0-386.839896-173.56626-386.839896-386.839896s173.56626-386.839896 386.839896-386.839896 386.839896 173.56626 386.839896 386.839896S734.177094 911.836898 520.903458 911.836898z"
						p-id="2522"
						fill="#31ACFF"
					></path>
					<path
						d="M713.402359 378.141115 713.402359 378.141115c-9.210474-8.289426-23.537877-7.470718-31.827304 1.739756L466.971017 619.046172l-110.218669-98.859085c-9.210474-8.289426-23.537877-7.470718-31.827304 1.739756l0 0c-8.289426 9.210474-7.470718 23.537877 1.739756 31.827304l126.490506 113.391165c0.102339 0.102339 0.204677 0.102339 0.307016 0.204677 0.102339 0.102339 0.204677 0.204677 0.204677 0.204677l0 0c9.210474 8.289426 23.537877 7.470718 31.827304-1.739756l229.647811-255.948831C723.431541 400.757945 722.612832 386.430542 713.402359 378.141115z"
						p-id="2523"
						fill="#31ACFF"
					></path>
				</svg>
				<p class="resultTxt">预约成功</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.container {
	width: 100%;
	height: 100%;
	background-color: #666;
	position: relative;
}
.tipWrap {
	padding: 20px 23px;
	background-color: #fff;
	width: 65%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 5%;
}
.tipTitle {
	color: #000;
	font-size: 16;
	margin-bottom: 23;
	text-align: center;
	font-weight: bold;
	margin-top: 0;
	margin-bottom: 24px;
}
.result_success {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.resultTxt {
	font-size: 14;
	color: #000;
	margin-top: 11px;
	margin-bottom: 42px;
}
.container /deep/ .confirmSuccessBtn {
	background-color: #31acff;
	font-size: 18px;
	color: #fff;
	height: 40px;
	width: 100%;
	border-radius: 5px;
}
.container /deep/ .handleBtn {
	width: 110px;
	font-size: 18px;
	color: #fff;
	height: 40px;
	border-radius: 5px;
}
.container /deep/ .cannelBtn {
	background-color: #e4e4e4;
	margin-right: 12px;
}
.container /deep/ .reapplyBtn {
	background-color: #31acff;
}
</style>
